/// <amd-module name="typeahead/features/FullscreenTypeahead" />
/// <amd-dependency path="jquery" name="$"/>

import {Experiment} from "typeahead/core/Experiment";
import {IExperimentalFeature} from "typeahead/core/IExperimentalFeature";
import {SuggestionSelectedMessage} from "typeahead/core/message/SuggestionSelectedMessage";
import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import {IInputElementFocusByHumanOrScriptHandler}
    from "typeahead/core/presentation/IInputElementFocusByHumanOrScriptHandler";
import * as StripingConfiguration from "typeahead/core/StripingConfiguration";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import {TypeaheadUtils} from "typeahead/core/TypeaheadUtils";

const configuration: IStripingConfiguration[] = [
    {
        experiment: {
            id: 24609,
            name: "TYPEAHEAD_FULL_SCREEN_HOTELS",
            value: 1,
        },
        tabs: ["hotel"],
    },
    {
        experiment: {
            id: 24610,
            name: "TYPEAHEAD_FULL_SCREEN_FLIGHTS",
            value: 1,
        },
        tabs: ["flight"],
    },
    {
        experiment: {
            id: 24611,
            name: "TYPEAHEAD_FULL_SCREEN_CARS",
            value: 1,
        },
        tabs: ["car"],
    },
    {
        experiment: {
            id: 24612,
            name: "TYPEAHEAD_FULL_SCREEN_PACKAGES",
            value: 1,
        },
        tabs: ["package", "packageFlightHotel", "packageFlightHotelCar", "packageFlightCar", "packageHotelCar",
            "flightHotel", "flightHotelCar", "flightCar", "hotelCar", "carHotel", "carHotelFlight", "carFlight"],
    },
];

export class FullscreenTypeahead
    implements IExperimentalFeature, IInputElementFocusByHumanOrScriptHandler<void>, IPageLoadHandler {

    private static cancelButtonHtml = `
        <button class="typeahead-overlay-cancel"><span class="uitk-icon">
        <svg role="img" aria-labelledby="icon-uitk-typeahead-cancel-title" viewBox="0 0 24 24" 
         style="fill:#616161; height:1.4em; width:1.4em;" xmlns="http://www.w3.org/2000/svg">
        <title id="icon-uitk-typeahead-cancel-title">Cancel</title> 
        <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"></path></svg></span></button>`;

    private static css = `
            .typeahead-overlay {
                background: rgba(245,245,245,1); 
                margin: 0;
                overflow: hidden !important; 
                padding: 0 !important;
                position: fixed !important;
                top: 0; right: 0; bottom: 0; left: 0;
                transition: top 0.3s;
                -moz-transition: top 0.3s;
                -webkit-transition: top 0.3s;                
                z-index: 99;
            }
            
            .typeahead-overlay-cancel {
                background-color: white;
                border:0;
                height: 52px;
                margin:0;
                padding-top: 6px;
                position: absolute;
                top: 0;
                width: 48px;
            }
            
            .typeahead-overlay input {       
                border: 0 !important;
                border-radius: 0 !important;   
                box-shadow: none !important;    
                height: 52px !important;               
                padding-left: 48px !important;
                padding-right: 48px !important;                
            }
            
            .typeahead-overlay label {     
                box-shadow: 0 2px 0.25rem 0 rgba(0,0,0,0.2) !important;         
                margin: 0;                
            }                        
            
            .typeahead-overlay button.btn-clear {
                height: 52px;
                margin-top: -12px;                
                right: 0;
                width: 48px;
            } 
            
            .typeahead-overlay .footer {
                display: none;
            }   
            
            .typeahead-overlay a.details {
                min-height:40px;
            }  
            
            .typeahead-overlay .autocomplete-open .autocomplete-arrow::after,
            .typeahead-overlay label span.label, 
            .typeahead-overlay label span.icon {
                display: none;
            }   
            
            .typeahead-overlay .autocomplete-dropdown {
                background: none;
                border: 0;
                box-shadow: none;
                height: -moz-calc(100% - 52px);
                height: -webkit-calc(100% - 52px);
                height: calc(100% - 52px);
                margin: 0;   
                max-width: 100% !important;
                overflow:auto;    
                width: 100% !important;                                              
            }    
            
            .typeahead-overlay .autocomplete-open {
                height: 100%;
            }
            
            .scroll-hidden {
                overflow: hidden;
                position: fixed;                
            }                                                   
        `;

    private static open($inputElement): void {
        let $typeaheadContainer = $($inputElement).closest("div.col");
        if (!$typeaheadContainer.hasClass("typeahead-overlay")) {
            if (location.search !== "?view=typeahead") {
                history.pushState(null, document.title, "?view=typeahead");
            }
            FullscreenTypeahead.disableOtherInputs($inputElement);
            $typeaheadContainer.addClass("typeahead-overlay");
            let cancelButton: JQuery = $.parseHTML(FullscreenTypeahead.cancelButtonHtml).pop();
            $typeaheadContainer.append(cancelButton);
            $("body").addClass("scroll-hidden");

            let close = () => {
                setTimeout(() => {
                    $("body").removeClass("scroll-hidden");
                    FullscreenTypeahead.enableOtherInputs($inputElement);
                    $(cancelButton).remove();
                    $typeaheadContainer.removeClass("typeahead-overlay");
                    TypeaheadMessage.unsubscribe(SuggestionSelectedMessage.getTopic(), suggestionSelectedSubscription);
                    $($inputElement).trigger("blur");
                    if (location.search === "?view=typeahead") {
                        window.history.back();
                    }
                    window.uitkautocomplete.prototype.closeAllTA();
                }, 0); // To fix click going through to the page behind
            };
            $(cancelButton).one("click", (event) => {event.preventDefault(); close(); });
            let suggestionSelectedSubscription =
                TypeaheadMessage.subscribe(SuggestionSelectedMessage.getTopic(), close);
            $(window).off("popstate.typeahead").on("popstate.typeahead", () => {
                if (location.search === "?view=typeahead") {
                    $inputElement.trigger("focus", true);
                } else {
                    close();
                }
            });
        }
    }

    private static disableOtherInputs($inputElement: JQuery): void {
        $($inputElement).closest("form").
        find("input:visible, select:visible").not($inputElement).attr("disabled", "true");
    }

    private static enableOtherInputs($inputElement: JQuery): void {
        $($inputElement).closest("form").
        find("input:visible, select:visible").not($inputElement).removeAttr("disabled");
    }

    public handlePageLoad(options: any, context: IContext): JQueryPromise<undefined> {
        let style = document.createElement("style");
        style.type = "text/css";
        style.innerHTML = FullscreenTypeahead.css;
        document.head.appendChild(style);
        return ($.Deferred() as JQueryDeferred<undefined>).resolve().promise();
    }

    public handleInputElementFocusByHumanOrScript($inputElement: JQuery, context: IContext): JQueryPromise<void> {
        if (TypeaheadUtils.isWithinMobileBreakpoint()) {
            ExecutionHelper.shouldExecute(context, configuration)
                .done((shouldExecute) => {
                    if (shouldExecute) {
                        FullscreenTypeahead.open($inputElement);
                    }
                });
        }
        return ($.Deferred() as JQueryDeferred<undefined>).resolve().promise();
    }

    public getExperiments(): Experiment[] {
        return StripingConfiguration.getExperiments(configuration);
    }
}
